import { satelliteTrack } from '@dc/data-layer/src/utils.js';
import { settings } from '@dc/ui-library';
import createAction from './createAction';
import totalPrices from '../../basket/total-prices.js';
import giftcardList from '../../basket/giftcard-list.js';
import translations from '../../components/react/OrderSummary/translations.js';

// 1. Initial state
const initialState = {
  voucher: [],
  basket: {},
  error: null
};

// 2. Actions;
const ADD_OFFER = 'orderSummaryPage/ADD_OFFER';
const REMOVE_OFFER = 'orderSummaryPage/REMOVE_OFFER';
const ERROR_OFFER = 'orderSummaryPage/ERROR_OFFER';
const CLEAR_ERROR = 'orderSummaryPage/CLEAR_ERROR';
const RELOAD_OFFER = 'orderSummaryPage/RELOAD_OFFER';

const REDEMPTION_URL = (settings.coupons && settings.coupons.redemptionUrl) || '';
const CANCELLATION_URL = (settings.coupons && settings.coupons.cancellationUrl) || '';

let isResp = false;
let wasTimeout = false;

// if no PHP response for 60s -> stop loader, throw error
const ifTimeout = (dispatch) => {
  setTimeout(() => {
    if (!isResp) {
      wasTimeout = true;
      dispatch(createAction(ERROR_OFFER)(translations.orderSummaryNoResponse));
    }
  }, 60000);
};

// 3. Action creators
export function addOffer(offer) {
  return (dispatch) => {
    ifTimeout(dispatch);
    const encodedCoupon =
      (encodeURIComponent(offer.replace(/\//g, '~').replace(/\./g, '_'))).toUpperCase();
    fetch(REDEMPTION_URL.replace('%7BcouponCode%7D', encodedCoupon), {
      credentials: 'same-origin'
    })
      .then((response) => response.json())
      .then((json) => {
        isResp = true;
        if (json.type === 'ERROR') {
          if (window.appState) {
            const eventData = { dData: offer, actions: 'Apply Coupon', success: false };
            window.appState.dispatch({ type: 'EVENTS_COUPON_INTERACTION', payload: eventData });
            satelliteTrack('couponInteraction');
          }
          return (
            dispatch(createAction(ERROR_OFFER)(json.message))
          );
        }
        // will be removed/changed after giftcards & Nemo vouchers refactoring
        totalPrices.update.discount(json.basket.discount);
        totalPrices.recalculate();
        if (giftcardList.isGiftcardsOn() && totalPrices.get.toPayWithoutSupport() < 0) {
          const overpayment = -totalPrices.get.toPayWithoutSupport();
          giftcardList.reduceCardsBy(overpayment, 0, true);
          giftcardList.calculateToPayAndUpdate();
          giftcardList.checkAmountToPayIsZero();
        }

        if (!wasTimeout) {
          // dispatch digitalData layer action
          if (window.appState && json.voucher.length > 0) {
            const eventData = { dData: json, actions: 'Apply Coupon', success: true };
            const cartData = { coupons: json, actions: 'add' };
            window.appState.dispatch({ type: 'EVENTS_COUPON_INTERACTION', payload: eventData });
            window.appState.dispatch({ type: 'CART_COUPON_UPDATE', payload: cartData });
            satelliteTrack('couponInteraction');
          }
          return dispatch(createAction(ADD_OFFER)(json));
        }
        return null;
      })
      .catch((error) => {
        dispatch(createAction(ERROR_OFFER)(error.message));
        isResp = true;
      });
  };
}

export function removeOffer(offer) {
  return (dispatch) => {
    ifTimeout(dispatch);
    fetch(CANCELLATION_URL.replace('%7BcouponCode%7D', offer), {
      credentials: 'same-origin'
    })
      .then((response) => response.json())
      .then((json) => {
        isResp = true;
        if (json.type === 'ERROR') {
          if (window.appState) {
            const eventData = { dData: offer, actions: 'Remove Coupon', success: false };
            window.appState.dispatch({ type: 'EVENTS_COUPON_INTERACTION', payload: eventData });
            satelliteTrack('couponInteraction');
          }
          return (
            dispatch(createAction(ERROR_OFFER)(json.message))
          );
        }

        totalPrices.update.discount(0);
        totalPrices.recalculate();
        if (!wasTimeout) {
          // dispatch digitalData layer action
          if (window.appState) {
            const eventData = { dData: offer, actions: 'Remove Coupon', success: true };
            const cartData = { coupons: offer, actions: 'remove' };
            window.appState.dispatch({ type: 'EVENTS_COUPON_INTERACTION', payload: eventData });
            window.appState.dispatch({ type: 'CART_COUPON_UPDATE', payload: cartData });
            satelliteTrack('couponInteraction');
          }
          return dispatch(createAction(REMOVE_OFFER)());
        }
        return null;
      })
      .catch((error) => {
        dispatch(createAction(ERROR_OFFER)(error.message));
        isResp = true;
      });
  };
}

export function clearError() {
  return createAction(CLEAR_ERROR)();
}

export function reloadOffer(offer) {
  return createAction(RELOAD_OFFER)(offer);
}

// 4. Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_OFFER:
      return {
        ...state,
        basket: action.payload.basket,
        voucher: [action.payload.voucher[0]]
      };
    case REMOVE_OFFER:
      return {
        ...state,
        basket: {},
        voucher: []
      };
    case ERROR_OFFER:
      return {
        ...state,
        error: action.payload
      };
    case CLEAR_ERROR:
      return {
        ...state,
        error: null
      };
    case RELOAD_OFFER:
      return {
        ...state,
        basket: action.payload.basket,
        voucher: [action.payload.voucher[0]]
      };
    default:
      return state;
  }
}
